import { render, staticRenderFns } from "./location-map.vue?vue&type=template&id=612dbe35&"
import script from "./location-map.vue?vue&type=script&lang=js&"
export * from "./location-map.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports